import cx from 'classnames';
import { faqItems } from '~/constants/dealership/testDriveCenter/content';
import styles from '../TestDriveCenter.module.css';

export default function TestDriveCenterFaq() {
  return (
    <section className="border-t border-[rgba(255,255,255,0.1)] bg-[var(--cvna-navy)]">
      <div className="mx-auto grid max-w-[1320px] grid-cols-[340px_1fr] items-start gap-[clamp(40px,6vw,88px)] px-[clamp(20px,4vw,56px)] py-[clamp(64px,8vh,104px)] max-[920px]:grid-cols-1">
        <div className={styles.animIn}>
          <div className={styles.eyebrow}>{'Questions'}</div>
          <h2 className="font-[family-name:var(--font-display)] text-[clamp(32px,3.6vw,52px)] font-black uppercase leading-[0.94] tracking-[-0.02em] text-white">
            {'Good to know'}
          </h2>
        </div>
        <div className={styles.animIn}>
          {faqItems.map((item, index) => (
            <details
              key={item.question}
              className={styles.faqItem}
              open={index === 0}
            >
              <summary
                className={cx(
                  styles.faqSummary,
                  'flex cursor-pointer list-none items-center justify-between gap-16 py-[22px] text-[18px] font-bold leading-[1.35] text-white'
                )}
              >
                {item.question}
                <span
                  aria-hidden
                  className={cx(
                    styles.faqPlus,
                    'flex-none text-[26px] font-light leading-none text-[var(--cvna-blue-bright)]'
                  )}
                >
                  +
                </span>
              </summary>
              <p className="m-0 max-w-[620px] pb-[22px] text-[16px] font-normal leading-[1.6] text-[rgba(255,255,255,0.74)]">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
